var map = {
	"./arrow_diag.svg": 5911,
	"./arrow_down.svg": 5793,
	"./build.svg": 4518,
	"./clear_button.svg": 6708,
	"./close.svg": 9192,
	"./close_small.svg": 4690,
	"./file.svg": 9690,
	"./linkedinIcon.svg": 634,
	"./linkedinIcon1.svg": 1429,
	"./logo_dark.svg": 7476,
	"./logo_light.svg": 9364,
	"./pharm.svg": 5298,
	"./retail.svg": 993,
	"./sprite.svg": 1134,
	"./telegramIcon.svg": 195,
	"./telegramIcon1.svg": 5027,
	"./trans.svg": 136,
	"./whatsapp.svg": 2106,
	"./whatsapp1.svg": 3173,
	"./whatsappIcon.svg": 6423
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 361;